<template>
  <f7-page name="settings">
    <f7-navbar>
      <f7-nav-title>Profil</f7-nav-title>
      <f7-nav-right v-if="profilePicture" class="profile-image__wrapper no-active-state">
        <img
          :src="profilePicture"
          alt="Pelikánec"
          class="margin-right-half profile-image__content"
        />
      </f7-nav-right>
    </f7-navbar>

    <f7-card>
      <f7-card-header class="margin-bottom-half">
        <span class="title">Prihlásený používateľ</span>
        <f7-icon ios="f7:person_fill" md="material:person" />
      </f7-card-header>
      <f7-card-content>
        <f7-list class="margin-bottom" strong inset dividers-ios>
          <f7-list-item :title="user?.name" header="Meno">
            <template #media>
              <f7-icon ios="f7:person" md="material:person_outline" />
            </template>
          </f7-list-item>

          <f7-list-item :title="user?.email" header="E-mail">
            <template #media>
              <f7-icon ios="f7:envelope" md="material:mail_outline" />
            </template>
          </f7-list-item>

          <f7-list-item :title="formattedRegistrationDate" header="Dátum registrácie">
            <template #media>
              <f7-icon ios="f7:calendar" md="material:calendar_today" />
            </template>
          </f7-list-item>
        </f7-list>

        <div v-if="!isProduction" class="margin-top">
          <f7-button color="green" small @click="logAuthorizationToken"
            >Generate JWT Token to console</f7-button
          >
          <f7-button color="green" small class="margin-top-half" @click="logGoogleAPIToken"
            >Generate Google API JWT Token to console</f7-button
          >
        </div>

        <f7-button class="margin-top" fill large color="red" @click="logout">Odhlásiť sa</f7-button>
      </f7-card-content>
    </f7-card>

    <f7-block class="text-align-center">
      <small class="version-text">Verzia: {{ version }}</small>
    </f7-block>
  </f7-page>
</template>

<script setup lang="ts">
import { useStore } from 'framework7-vue'
import { DateTime } from 'luxon'
import { computed, onMounted, ref } from 'vue'

import { getAuthorizationToken, getGoogleProviderToken, useLogout } from '@/assets/composables/auth'
import type { User } from '@/assets/composables/types'

const logout = useLogout()

const isProduction = import.meta.env.PROD
const user = computed<User | null>(() => useStore('user').value)
const profilePicture = computed(() => {
  const picture = user.value?.prefs.picture
  return typeof picture === 'string' ? picture : undefined
})
const version = ref('')

const formattedRegistrationDate = computed(() => {
  if (!user.value?.registration) return ''
  return DateTime.fromISO(user.value.registration)
    .setLocale('sk')
    .toLocaleString(DateTime.DATE_FULL)
})

const logAuthorizationToken = async () => {
  console.log(await getAuthorizationToken())
}

const logGoogleAPIToken = async () => {
  console.log((await getGoogleProviderToken()) ?? 'No Google API token available')
}

onMounted(() => {
  version.value = __APP_VERSION__
})
</script>

<style scoped lang="scss">
.ios .navbar .profile-image__wrapper {
  backdrop-filter: none;
  box-shadow: none;
  background-color: transparent;
}

.profile-image {
  &__wrapper {
    height: 80%;
    width: auto;
  }

  &__content {
    width: auto;
    height: 100%;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #fff;
  }
}

.version-text {
  color: var(--f7-text-color);
  opacity: 0.5;
}
</style>
